import { api } from './api';

export const tags = api.injectEndpoints({
  endpoints: builder => ({
    getTags: builder.query({
      query: ({ search }: { search?: string } = {}) => {
        return {
          url: 'trips/documents/tags/',
          params: search ? { search } : undefined,
        };
      },
      providesTags: [{ type: 'Tag', id: 'LIST' }],
      keepUnusedDataFor: 5,
    }),
    addTag: builder.mutation({
      query: ({ name, color }) => {
        return {
          url: 'trips/documents/tags/',
          method: 'POST',
          body: {
            name,
            color,
          },
        };
      },
      invalidatesTags: ['TripDocuments', 'Documents', 'Tag'],
    }),
    deleteTag: builder.mutation({
      query: ({ id }) => {
        return {
          url: `trips/documents/tags/${id}/`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['TripDocuments', 'Documents', 'Tag'],
    }),
    updateTag: builder.mutation({
      query: ({ id, name, color }) => {
        return {
          url: `trips/documents/tags/${id}/`,
          method: 'PUT',
          body: {
            name,
            color,
          },
        };
      },
      invalidatesTags: ['TripDocuments', 'Documents', 'Tag'],
    }),
  }),
});

export const { useGetTagsQuery, useAddTagMutation, useDeleteTagMutation, useUpdateTagMutation } = tags;
